export const TASK_TITLE_MAX_LENGTHApi = 255;
export const TASK_DESCRIPTION_MAX_LENGTHApi = 2000;
export var TaskStatusApi;
(function (TaskStatusApi) {
    TaskStatusApi["IN_PROGRESS"] = "in_progress";
    TaskStatusApi["CLOSED_RESOLVED"] = "closed_resolved";
    TaskStatusApi["CLOSED_DELETED"] = "closed_deleted";
})(TaskStatusApi || (TaskStatusApi = {}));
export var TaskListApi;
(function (TaskListApi) {
    TaskListApi["DEFAULT_LIST"] = "default_list";
})(TaskListApi || (TaskListApi = {}));
export var TaskSourceTypeApi;
(function (TaskSourceTypeApi) {
    TaskSourceTypeApi["PROJECT"] = "project";
    TaskSourceTypeApi["TASK_GROUP_SECTION"] = "task_group_section";
})(TaskSourceTypeApi || (TaskSourceTypeApi = {}));
export var TaskGroupSourceTypeApi;
(function (TaskGroupSourceTypeApi) {
    TaskGroupSourceTypeApi["PROJECT"] = "project";
    TaskGroupSourceTypeApi["GROUP"] = "group";
    TaskGroupSourceTypeApi["USER"] = "user";
    TaskGroupSourceTypeApi["BID"] = "bid";
})(TaskGroupSourceTypeApi || (TaskGroupSourceTypeApi = {}));
export var TaskGroupStatusApi;
(function (TaskGroupStatusApi) {
    TaskGroupStatusApi["OPEN"] = "open";
    TaskGroupStatusApi["REMOVED"] = "removed";
})(TaskGroupStatusApi || (TaskGroupStatusApi = {}));
export var TaskGroupSectionStatusApi;
(function (TaskGroupSectionStatusApi) {
    TaskGroupSectionStatusApi["OPEN"] = "open";
    TaskGroupSectionStatusApi["REMOVED"] = "removed";
})(TaskGroupSectionStatusApi || (TaskGroupSectionStatusApi = {}));
export var TaskActionApi;
(function (TaskActionApi) {
    TaskActionApi["TASK_CREATE"] = "task_create";
    TaskActionApi["TASK_UPDATE"] = "task_update";
})(TaskActionApi || (TaskActionApi = {}));
export var TaskActionDetailApi;
(function (TaskActionDetailApi) {
    TaskActionDetailApi["ASSIGNEE_ID"] = "assignee_id";
    TaskActionDetailApi["DESCRIPTION"] = "description";
    TaskActionDetailApi["DUE_DATE"] = "due_date";
    TaskActionDetailApi["STATUS"] = "status";
    TaskActionDetailApi["TASK_LIST"] = "task_list";
    TaskActionDetailApi["TITLE"] = "title";
})(TaskActionDetailApi || (TaskActionDetailApi = {}));
export var TaskActionSourceTypeApi;
(function (TaskActionSourceTypeApi) {
    TaskActionSourceTypeApi["ADMIN"] = "admin";
    TaskActionSourceTypeApi["USER"] = "user";
})(TaskActionSourceTypeApi || (TaskActionSourceTypeApi = {}));
export var TasksOrderOptionApi;
(function (TasksOrderOptionApi) {
    TasksOrderOptionApi["ID"] = "id";
    TasksOrderOptionApi["DUE_DATE"] = "due_date";
    TasksOrderOptionApi["POSITION"] = "position";
})(TasksOrderOptionApi || (TasksOrderOptionApi = {}));
